import React from 'react';
import ProgrammePageRenderer from '../components/ProgrammePageRenderer';

const seatToken = {
  hero: { section_key: 'hero', section_type: 'hero', image: '/images/page-banners/foundational.webp' },
  intro: {
    section_key: 'intro',
    section_type: 'intro',
    kicker: 'Foundational Programme',
    title: 'Where Curiosity Becomes Confidence',
    image: '/images/our-program/foundation-1.webp',
    description:
      "The early years of education shape how children think, communicate, build relationships, and learn throughout their lives.\n\nAt St. Andrews World School, Indirapuram, our Foundational Programme offers a joyful, purposeful start to the ICSE pathway. Through play, storytelling, movement, art, and hands-on discovery, children build essential skills in a secure and nurturing environment.\n\nRather than rushing formal academics, we foster the confidence, curiosity, and capabilities needed for lifelong learning.",
    extra: { chip_text: 'Classes: Pre-Nursery to Class II', chip_icon: 'fa-graduation-cap' },
  },
  steps: {
    section_key: 'steps',
    section_type: 'steps',
    kicker: 'Learning Through Experience',
    title: 'Understanding That Comes From Doing',
    description:
      'Children grasp concepts best by experiencing them firsthand before encountering abstract ideas.\n\nStories build language, objects bring numbers to life, movement improves coordination, and guided discussions encourage observation, comparison, and clear expression.',
    extra: {
      journey_label: 'Our learning journey progresses naturally',
      steps: ['Experience', 'Observation', 'Questioning', 'Reasoning', 'Understanding'],
      closing: 'This approach enables children to participate actively in learning rather than simply receive information.',
      experiences: ['Stories', 'Play', 'Movement', 'Observation', 'Art', 'Music', 'Practical Exploration'],
    },
  },
  foundations_header: {
    section_key: 'foundations_header',
    section_type: 'header',
    kicker: 'The Foundations We Build',
    title: 'A Strong Start in Every Dimension',
  },
  card_1: {
    section_key: 'card_1',
    section_type: 'card',
    icon: 'fa-comments',
    title: 'Language, Literacy and Communication',
    description:
      'Interactive stories, rhymes, phonics, and discussions develop listening, speaking, reading, and writing skills, enabling children to communicate with confidence.',
  },
  card_2: {
    section_key: 'card_2',
    section_type: 'card',
    icon: 'fa-calculator',
    title: 'Numeracy and Problem Solving',
    description:
      'Numbers, shapes, patterns, and measurement are introduced through games and everyday objects, building intuitive understanding over rote memorisation.',
  },
  card_3: {
    section_key: 'card_3',
    section_type: 'card',
    icon: 'fa-people-arrows',
    title: 'Social and Emotional Confidence',
    description:
      'Classroom routines and group activities foster empathy, teamwork, patience, and self-regulation, empowering children to embrace new challenges with resilience.',
  },
  card_4: {
    section_key: 'card_4',
    section_type: 'card',
    icon: 'fa-palette',
    title: 'Creativity and Physical Development',
    description: 'Art, music, dance, play, and physical activities enhance creativity, coordination, focus, and overall well-being.',
  },
  teachers: {
    section_key: 'teachers',
    section_type: 'split',
    kicker: 'Personalised Guidance',
    title: 'Teachers Who Know and Guide Every Child',
    image: '/images/our-program/foundation-2.webp',
    description:
      'Our educators understand that children learn at their own pace. Through careful observation and personalised guidance, they provide the right balance of support and challenge.',
    extra: { bg: 'navy' },
  },
  next_stage: {
    section_key: 'next_stage',
    section_type: 'header',
    kicker: 'Preparing for the Next Stage',
    title: 'Ready, Confident and Curious',
    description:
      'By the end of Class II, students gain strong foundations in literacy, numeracy, communication, independence, and social readiness.\n\nThey learn to question, solve problems, collaborate, and approach learning with confidence, ensuring a smooth transition to the next ICSE stage.',
    extra: { closing: 'Strong beginnings create capable learners\u2014and confident futures.', bg: 'light' },
  },
  cta: {
    section_key: 'cta',
    section_type: 'cta',
    icon: 'fa-comment-dots',
    title: 'Beyond the Classroom. Ready for the World.',
    description: 'Discover the joy of learning at the Foundational Programme of St. Andrews World School, Indirapuram.',
    button_text: 'Explore Our Programmes',
    button_url: '/our-programmes',
    button2_text: 'Enquire for Admission',
    button2_url: '/admission',
  },
};

const DEFAULT_SECTIONS = [
  seatToken.hero,
  seatToken.intro,
  seatToken.steps,
  seatToken.foundations_header,
  seatToken.card_1,
  seatToken.card_2,
  seatToken.card_3,
  seatToken.card_4,
  seatToken.teachers,
  seatToken.next_stage,
  seatToken.cta,
];

const seo = {
  title: 'Foundational Programme',
  description: 'Where curiosity becomes confidence — the Foundational Programme (Pre-Nursery to Class II) at St. Andrews World School, Indirapuram.',
  keywords: 'Foundational Programme, Pre-Nursery, Nursery, ICSE school Indirapuram, St Andrews World School',
};

const FoundationalProgrammePage = () => (
  <ProgrammePageRenderer pageKey="foundational" defaults={DEFAULT_SECTIONS} seo={seo} />
);

export default FoundationalProgrammePage;